import React, { PropTypes } from 'react';

const DeckListFilter = ({ filter, onChange }) => {
    return <div className="filter">
        <input onChange={ evt => onChange(evt.target.value) } value={ filter } />
        <span className="fa fa-search"></span>
    </div>;
};

DeckListFilter.propTypes = {
    filter: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

export default DeckListFilter;


// WEBPACK FOOTER //
// ./src/components/decklist/filter.js